import { 
  TrendingUp, Award, Users, CheckCircle, 
  Home, Key, Calculator, Scale,
  Shield, Heart, Target, FileText,
  Building, Briefcase, Map, Sofa,
  Clock, Wrench, CreditCard, Calendar,
  DollarSign, Eye, HeartHandshake, User,
  ArrowRight, Phone, Mail, MapPin,
  Search, Filter, Star, Zap
} from 'lucide-react';

export const iconMap = {
  TrendingUp,
  Award,
  Users,
  CheckCircle,
  Home,
  Key,
  Calculator,
  Scale,
  Shield,
  Heart,
  Target,
  FileText,
  Building,
  Briefcase,
  Map,
  Sofa,
  Clock,
  Wrench,
  CreditCard,
  Calendar,
  DollarSign,
  Eye,
  HeartHandshake,
  User,
  ArrowRight,
  Phone,
  Mail,
  MapPin,
  Search,
  Filter,
  Star,
  Zap
};

export function getIcon(iconName: string) {
  return iconMap[iconName as keyof typeof iconMap] || null;
}